/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './common-configurator.model';
export * from './configurator-product-scope';
export * from './product-configurator.config';
// Imported for side effects (module augmentation)
import './augmented-core.model';
